import React from 'react';
import { Button } from '../components/ui/Button';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
export function Contact() {
  return <div className="pt-12 pb-20 bg-gray-50" data-id="element-305">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-306">
        <div className="text-center mb-16" data-id="element-307">
          <h1 className="text-4xl font-bold text-gray-900 mb-6" data-id="element-308">Contact Us</h1>
          <p className="text-xl text-gray-600" data-id="element-309">
            We'd love to hear from you. Get in touch for a quote or questions.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-310">
          {/* Contact Form */}
          <div className="bg-white rounded-2xl shadow-sm p-8" data-id="element-311">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-312">
              Send us a message
            </h2>
            <form className="space-y-6" data-id="element-313">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-314">
                <div data-id="element-315">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-316">
                    Name
                  </label>
                  <input type="text" id="name" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-wh-pink focus:border-wh-pink" data-id="element-317" />
                </div>
                <div data-id="element-318">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-319">
                    Email
                  </label>
                  <input type="email" id="email" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-wh-pink focus:border-wh-pink" data-id="element-320" />
                </div>
              </div>
              <div data-id="element-321">
                <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-322">
                  Subject
                </label>
                <input type="text" id="subject" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-wh-pink focus:border-wh-pink" data-id="element-323" />
              </div>
              <div data-id="element-324">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-325">
                  Message
                </label>
                <textarea id="message" rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-wh-pink focus:border-wh-pink" data-id="element-326"></textarea>
              </div>
              <Button variant="primary" className="w-full" data-id="element-327">
                Send Message
              </Button>
            </form>
          </div>

          {/* Contact Info */}
          <div className="space-y-8" data-id="element-328">
            <div className="bg-white rounded-2xl shadow-sm p-8" data-id="element-329">
              <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-330">
                Contact Information
              </h3>
              <ul className="space-y-6" data-id="element-331">
                <li className="flex items-start" data-id="element-332">
                  <MapPin className="w-6 h-6 text-wh-pink mr-4 flex-shrink-0" data-id="element-333" />
                  <div data-id="element-334">
                    <span className="block font-medium text-gray-900" data-id="element-335">
                      Address
                    </span>
                    <span className="text-gray-600" data-id="element-336">
                      4425 West US 20, Suite 1<br data-id="element-337" />
                      LaGrange, Indiana 46761
                    </span>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-338">
                  <Phone className="w-6 h-6 text-wh-pink mr-4 flex-shrink-0" data-id="element-339" />
                  <div data-id="element-340">
                    <span className="block font-medium text-gray-900" data-id="element-341">
                      Phone
                    </span>
                    <a href="tel:260-463-7373" className="text-gray-600 hover:text-wh-pink" data-id="element-342">
                      260-463-7373
                    </a>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-343">
                  <Mail className="w-6 h-6 text-wh-pink mr-4 flex-shrink-0" data-id="element-344" />
                  <div data-id="element-345">
                    <span className="block font-medium text-gray-900" data-id="element-346">
                      Email
                    </span>
                    <a href="mailto:wearhaus@wearhaus.net" className="text-gray-600 hover:text-wh-pink" data-id="element-347">
                      wearhaus@wearhaus.net
                    </a>
                  </div>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-2xl shadow-sm p-8" data-id="element-348">
              <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-349">
                Business Hours
              </h3>
              <ul className="space-y-4" data-id="element-350">
                <li className="flex items-center justify-between" data-id="element-351">
                  <span className="text-gray-600" data-id="element-352">Monday – Friday</span>
                  <span className="font-medium text-gray-900" data-id="element-353">
                    8:00 AM – 4:00 PM
                  </span>
                </li>
                <li className="flex items-center justify-between" data-id="element-354">
                  <span className="text-gray-600" data-id="element-355">Saturday – Sunday</span>
                  <span className="font-medium text-gray-900" data-id="element-356">Closed</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>;
}